import React from 'react';

import SelectWidget from '@plone/volto/components/manage/Widgets/SelectWidget';
import { Icon } from '@designsystem/stories/02-atoms/Icon';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import checkSVG from '@plone/volto/icons/check.svg';
import checkBlankSVG from '@plone/volto/icons/check-blank.svg';
import VoltoIcon from '@plone/volto/components/theme/Icon/Icon';

const Option = injectLazyLibs('reactSelect')((props: any) => {
  const { Option } = props.reactSelect.components;
  const color = props.isFocused && !props.isSelected ? '#b8c6c8' : '#007bc1';
  const svgIcon =
    props.isFocused || props.isSelected ? checkSVG : checkBlankSVG;

  return (
    <Option className="icon-widget__option" {...props}>
      <Icon icon={props.value} />
      <div className="icon-widget__option-label">{props.label}</div>
      <VoltoIcon name={svgIcon} size="20px" color={color} />
    </Option>
  );
});

const IconWidget: React.FC<any> = (props) => {
  return (
    <div className="icon-widget">
      <SelectWidget {...props} customOptionStyling={Option} />
    </div>
  );
};

export default IconWidget;
